export default __webpack_public_path__ + "static/v2flawless-853c0bd27773238071ab6ab4dd6fabd3.png";